import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { SecurityService } from '../../shared/services/security.service';
import {tipo_cliente} from '../../shared/object/tipo_cliente.model';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: 'app-tipoclie',
  templateUrl: './tipoclie.component.html',
  styleUrls: ['./tipoclie.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class TipoclieComponent implements OnInit {
  private client: GraphQLClient = null;
  tipoclienteList: tipo_cliente[];
  selectedTipoCliente: tipo_cliente;
  tipocliente: tipo_cliente;

  
  public formAgregarTipoCliente: FormGroup;
  public formEditarTipoCliente: FormGroup;

  public rut_empresa;
  public sucursal_codigo;

  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('centralLargex', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 11;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());

  constructor(client: GraphQLClient, 
    private accesolocalstorage:SecurityService,
    public validadores: ValidadoresService ) { 
    this.client = client;
    this.formAgregarTipoCliente = this.construyeFormAgrega();
    this.formEditarTipoCliente = this.construyeFormEdita();
  }

  ngOnInit() {
    this.selectedTipoCliente = {
      codigo:'',
      descripcion: '',
      empresa_rut: this.accesolocalstorage.getRutEmpresa()
      
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();
  
    this.obtenerDatosTipoCliente();
  }

  construyeFormAgrega() {
    return new FormGroup({
      codigo: new FormControl('', [Validators.required, Validators.maxLength(3), Validators.minLength(3)]),
      descripcion: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(15)]),
    });
  }

  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl({value:'', disabled:true}, [Validators.required, Validators.maxLength(3), Validators.minLength(3)]),
      descripcion: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(15)])
    });
  }

  get frmAgregaCodigo() { return this.formAgregarTipoCliente.get('codigo'); }
  get frmAgregaDescripcion() { return this.formAgregarTipoCliente.get('descripcion'); }

  get frmEditarCodigo() { return this.formEditarTipoCliente.get('codigo'); }
  get frmEditarDescripcion() { return this.formEditarTipoCliente.get('descripcion'); }

  obtenerDatosTipoCliente() {
    //console.log("obtenerDatosnew")
    let self = this; // this is unused

    this.client.query({
      query: gql`
        query($empresa:Decimal)
        {
          tipo_cliente{
            obtenerSegunFiltro(filtro:{
              exacto:{
                empresa_rut:$empresa
              }})
              {
                mensajes{
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros{
                    codigo
                    descripcion
                    empresa_rut
                  }
                }
              }
          }
        }
      `
      ,fetchPolicy: 'network-only',
      variables: {
        "empresa": this.rut_empresa
      }

    }, function (respuesta) {
      self.tipoclienteList = respuesta.data.tipo_cliente.obtenerSegunFiltro.respuesta.registros;
    });
  }

  ValidaQueExisteDatosTipoCliente()
  {
    let self = this; // this is unused

    this.tipocliente = {
      codigo: String(this.frmAgregaCodigo.value).toUpperCase(),
      empresa_rut: this.rut_empresa,
      descripcion: this.frmAgregaDescripcion.value,
    };

    this.client.query({
      query: gql`
      query ($entidad:tipo_clienteInputType)
      {
        tipo_cliente
        {
          existe
          (entidad:$entidad)
          {
            respuesta
          }
        }
      }
      `
      ,fetchPolicy: 'network-only',
      variables: {
        "entidad": this.tipocliente
      }
    }, function (respuesta) {
          if (respuesta.data.tipo_cliente.existe.respuesta) {
            var res = window.confirm("El código de tipo de cliente ya existe. ¿Desea sobreescribir los datos existentes?");
            if (res) {
              self.guardarTipoCliente(self.tipocliente);
            }
          }
          else {
            self.insertar();
          }

    });
  }

  guardarTipoCliente(tipocliente: tipo_cliente) {
    let self = this;
    var bodyx = tipocliente;



    this.client.mutate({
      mutation: gql`
        mutation($entidad: tipo_clienteInputType
          )
        {
          tipo_cliente
          {
          guardar(entidad: $entidad) {
              respuesta{
                codigo
                descripcion
              }
            }
          }
        }
       `
      ,
      variables: {
        'entidad': bodyx,
      }
    }, function (respuesta) {
      setTimeout(() => self.obtenerDatosTipoCliente(), 1000);
    });
  }

  insertar() {
    this.selectedTipoCliente.descripcion = this.frmAgregaDescripcion.value;
    this.selectedTipoCliente.codigo = String(this.frmAgregaCodigo.value).toUpperCase();


    this.postTipoCliente(this.selectedTipoCliente);
    this.selectedTipoCliente = {
      codigo: "",
      descripcion: "",
      empresa_rut: this.rut_empresa
    };
  }
  muestraModalAgrega()
  {
    this.selectedTipoCliente = {
      codigo: "",
      descripcion:'',
      empresa_rut: this.rut_empresa
    };
    this.formAgregarTipoCliente.reset();
  }

  postTipoCliente(tipocli: tipo_cliente) {
    let self = this;
    var bodyx = tipocli;
    //var self = this;
    this.client.mutate({
      mutation: gql`
        mutation($entidad: tipo_clienteInputType)
        {
          tipo_cliente
          {
          agregar(entidad: $entidad) {
              respuesta{
                codigo
                descripcion
              }
            }
          }
        }
       `
       ,
      variables: {
        'entidad': bodyx,
      }
    }, function (respuesta) {
      setTimeout(() => self.obtenerDatosTipoCliente(), 1000);

    });
  }
  
  
  actualizar() {
    this.selectedTipoCliente.codigo = this.frmEditarCodigo.value;
    this.selectedTipoCliente.descripcion = this.frmEditarDescripcion.value;

    this.refrescar(this.selectedTipoCliente);
    this.selectedTipoCliente = {
      codigo: "",
      descripcion: '',
      empresa_rut: this.rut_empresa
    };
  }

  refrescar(tipocli: tipo_cliente) {
    let self = this;
    var bodyx = tipocli;
    
    delete tipocli["__typename"];
    this.client.mutate({
      mutation: gql`
        mutation($entidad: tipo_clienteInputType
          )
        {
          tipo_cliente
          {
          modificar(entidad: $entidad) {
              respuesta{
                codigo
                descripcion
              }
            }
          }
        }
       `
       ,
      variables: {
        'entidad': bodyx,
      }
    }, function (respuesta) {
      setTimeout(() => self.obtenerDatosTipoCliente(), 1000);

    });
  }

  showForEdit(tipocli: tipo_cliente) {
    //console.log(vend);

    this.formEditarTipoCliente.reset();
    this.selectedTipoCliente = Object.assign({}, tipocli);

    this.frmEditarDescripcion.setValue(tipocli.descripcion);
    this.frmEditarCodigo.setValue(tipocli.codigo);
  
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
